import styled from "@emotion/styled";
import { Variables } from "@repo/skapa";

import { FlexDiv } from "./FlexDiv";

export const ButtonsContainer = styled(FlexDiv)`
  gap: ${Variables.space50};
  justify-content: ${(props) =>
    props.justifyContent ? props.justifyContent : "center"};
  align-items: center;
`;

export const RightAlignedButtonWrapper = styled.div`
  margin-left: auto;
`;
